module.exports = __webpack_public_path__ + "img/active-quest.b67b7d15.svg";